var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { BUTTON_TYPE_STYLES } from "../Button";
import { useButtonClasses } from "../Button/Button.styles";
import { hasUtilityStyle, useUtilityStyles, UtilityStyle, } from "../hooks/useUtilityStyles";
import { Client } from "../theming/ThemeProvider";
import { useThemeContext } from "../theming/useThemeContext";
import { classNames } from "../utils/classNames";
import { isDefined } from "../utils/isDefined";
export function Link(props) {
    var _a;
    var styleOptions = props.styleOptions;
    var client = useThemeContext().client;
    var type = (_a = props === null || props === void 0 ? void 0 : props.type) !== null && _a !== void 0 ? _a : "default";
    var classes = useButtonClasses(type, hasUtilityStyle(styleOptions, UtilityStyle.Block));
    var utilityStyles = useUtilityStyles(styleOptions);
    var _b = getLinkAttributes(props), Element = _b.Element, linkAttributes = _b.linkAttributes;
    return (React.createElement(Element, __assign({}, linkAttributes, { className: client === Client.Portal
            ? classNames(classes.button, classes.baseButton, utilityStyles.utilities)
            : classNames("btn", "btn-".concat(BUTTON_TYPE_STYLES[type]), utilityStyles.utilities), "data-id": props === null || props === void 0 ? void 0 : props.dataId, "data-testid": props === null || props === void 0 ? void 0 : props.dataTestId }), props.label));
}
export function getLinkAttributes(props) {
    var Element = "a";
    var linkAttributes = {};
    if (isDefined(props.routerLink)) {
        Element = props.routerLink;
        linkAttributes = {
            to: props === null || props === void 0 ? void 0 : props.url,
            url: props === null || props === void 0 ? void 0 : props.url,
        };
    }
    else {
        linkAttributes = {
            href: props === null || props === void 0 ? void 0 : props.url,
        };
    }
    return { linkAttributes: linkAttributes, Element: Element };
}
